import 'moment/locale/pt-br';
import { formatMoney } from '../../../infra/helpers';
import type { ColumnsType } from 'antd/es/table';
import { formatBrDate } from '../../../infra/helpers/date';
import { formatNumber } from '../../../infra/helpers/number';

export const colunas: ColumnsType = [
  {
    title: "Numero da NFe",
    dataIndex: "Numero",
    key: "Numero",
    render: (record: string) => {
      return (
        <span>
          {String(record).padStart(6, '0')}
        </span>
      );
    }
  },
  {
    title: "Contato",
    dataIndex: "ContatoNome",
    key: "ContatoNome",
  },
  {
    title: "Vendedor",
    dataIndex: "Vendedor",
    key: "Vendedor",
  },
  {
    title: "Valor da Nota Fiscal",
    dataIndex: "ValorTotalNotaReais",
    key: "ValorTotalNotaReais",
    render(valor: number) {
      return formatMoney(valor);
    },
    align: "right",
    width: 170,
  },
  {
    title: "% de Comissão",
    dataIndex: "ComissaoPorcentagem",
    key: "ComissaoPorcentagem",
    render(valor: number) {
      return `${formatNumber(valor)}%`;
    },
    align: "right",
    width: 130,
  },
  {
    title: "Data da Nota Fiscal",
    dataIndex: "NotaFiscalData",
    key: "NotaFiscalData",
    render(data: string) {
      return formatBrDate(data)
    },
  },
];
